import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import { getStatusModalCloseSite } from '~/services/comment';

export default function ModalOutsideTaiwan() {
  const [show, setShow] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    try {
      getStatusModalCloseSite().then((response) => {
        if (response.isNotFromTaiwan) {
          if (response.modal_out_side_taiwan === 1) {
            setShow(true);
          } else {
            const isShowPopup = localStorage.getItem(
              'isShowModalOutSideTaiwan',
            );
            if (!isShowPopup) {
              setShow(true);
            }
          }

          // if (response.errorType) {
          //   const isShowPopup = localStorage.getItem(
          //     'isShowModalOutSideTaiwan',
          //   );
          //   if (!isShowPopup) {
          //     setShow(true);
          //   }
          // }
        }
      });
    } catch (error) {
      console.log('vo day ne', error);
    }
  }, []);

  const handleClose = () => {
    setShow(false);

    if (checked) {
      getStatusModalCloseSite({
        modal_out_side_taiwan: 0,
        isUpdateStatus: true,
      });
      localStorage.setItem('isShowModalOutSideTaiwan', 'false');
    }
  };

  return (
    <Modal
      bsSize="md"
      show={show}
      onHide={handleClose}
      className="attribute-modal"
    >
      <div className="" style={{ padding: '40px' }}>
        <button className="close-btn" onClick={handleClose}>
          &times;
        </button>
        <p
          style={{ fontSize: '16px', fontWeight: 'bold', textAlign: 'center' }}
        >
          {/* From December 1, 2025, this site will no longer be available in your
          region. */}
          We sincerely apologize, but this site is no longer available in your
          region.
        </p>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <input
            type="checkbox"
            style={{
              margin: 0,
              width: 16,
              height: 16,
              display: 'block',
            }}
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
          />
          <small
            style={{
              padding: 0,
              marginLeft: 8,
            }}
          >
            Do not show this modal again
          </small>
        </div>
        {/* <div className="" style={{ textAlign: 'center', marginTop: '20px' }}>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </div> */}
      </div>
      <style jsx>{`
        .close-btn {
          position: absolute;
          top: 6px;
          right: 8px;
          background: transparent;
          border: none;
          font-size: 20px;
          line-height: 1;
          cursor: pointer;
        }

        .close-btn:hover {
          opacity: 0.8;
        }
      `}</style>
    </Modal>
  );
}
